<template>
  <section class="footer-section" id="footer">
    <div class="container">
      <div class="footer-heading">
        Пусть 2021 год будет радостным и позитивным,
        от&nbsp;нас – приятные подарки
      </div>
      <form
        class="form"
        id="sendsay_form"
        name="form_76"
        ref="formMain"
        v-on:keypress.13.prevent="sendMail"
        accept-charset="utf-8">
        <div class="form-input first-input" id="_member_email">
          <label for="emailSendsay">
            Ваша почта
          </label>
          <input
            type="email"
            class="form-control sendsayFieldItem"
            placeholder="Введите почту"
            required
            name="_member_email"
            id="emailSendsay"/>
          <input type="hidden" name="q923" value="" id="valueSendsay"/>
        </div>
        <div
          class="form-checkbox first-input"
          v-bind:class="{ checkedbox: checked }" >
          <label for="checkPolit">
            <input type="checkbox" id="checkPolit" checked v-model="checked">
              Я даю согласие на получение
              выгодных рекламных предложений
              от ПАО «МТС» на указанный email-адрес.
          </label>
        </div>
        <div class="form-submit first-input">
          <button class="btn" id="getGifts" type="button"
                  ref="buttonSubmit" v-on:click="sendMail()" :disabled="!checked">
            Получить подарки
          </button>
        </div>
        <div class="thankyou">
          <strong>Спасибо!</strong><br>
          <span>Письмо с подарками отправлено вам на почту</span>
        </div>
      </form>
      <div class="gift-image">
        <img
          :src="require('@/assets/image/footer-section/giftbox.png')"
          alt="giftimage"
          class="giftimage">
      </div>
      <div class="instagram-block">
        <div class="instagram-heading">
          Каким будет ваш 2021 год?
        </div>
        <div class="instagram-about">
          <div class="instagram-about__image">
            <a href="https://instagram.com/2021mts?igshid=eo9sihnu54z4" id="goToInst" target="_blank">
              <img
                :src="require('@/assets/image/footer-section/masks.png')"
                alt="masks"
                class="masks">
            </a>
          </div>
          <div class="instagram-about__text">
            Заглянуть в будущее поможет наша Instagram-маска
          </div>
        </div>
        <div class="instagram-btn">
          <a href="https://www.instagram.com/ar/1515116782016278"
             target="_blank" id="getMasks" class="btn">
            Примерить маску
          </a>
        </div>
      </div>
      <div class="footer-copyright">
        © 2021 ПАО «МТС» Все права защищены
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import axios from 'axios';

export default {
  name: 'v-footer-section',
  mounted() {
    const timelineFooter = gsap.timeline({
      scrollTrigger: {
        trigger: '.footer-section',
        start: '-=70%',
        end: '50%',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress_footer:', self.progress);
          const footer = document.getElementById('footer');
          if (self.progress > 0.2 && self.direction === 1 && !footer.classList.contains('active')) {
            // document.body.style.background = '#E30611';
            footer.classList.add('active');
            TweenMax.fromTo('.footer-section', {
              y: 150,
              opacity: 0,
            }, {
              y: 50,
              opacity: 1,
            });
            TweenMax.fromTo('.footer-section .container', {
              backgroundPositionX: 0,
              backgroundPositionY: 0,
            }, {
              backgroundPositionX: '100%',
              backgroundPositionY: '100%',
            });
          }
          if (self.progress < 0.2 && self.direction === -1 && footer.classList.contains('active')) {
            // document.body.style.background = '#F4F4F4';
            footer.classList.remove('active');
            TweenMax.to('.footer-section', {
              opacity: 0,
            });
          }
        },
      },
    });
    timelineFooter.addLabel('start');

    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const hiddenValue = params.get('M');
    const valueSendsay = document.getElementById('valueSendsay');
    // console.log(hiddenValue);
    if (hiddenValue != null) {
      valueSendsay.value = hiddenValue;
    }
  },
  data() {
    return {
      checked: true,
    };
  },
  created() {
    const ckeditor = document.createElement('script');
    ckeditor.setAttribute('src', 'https://sendsay.ru/account/js/formCheck.js?20170516');
    document.head.appendChild(ckeditor);
  },
  methods: {
    sendMail() {
      // eslint-disable-next-line no-unused-vars,camelcase,no-unused-expressions
      const PS_ErrPref = 'Поля не заполнены или заполнены неверно: \n';
      const valueInput = document.getElementById('emailSendsay');
      const valueSendsay = document.getElementById('valueSendsay').value;
      const emailSendsay = valueInput.value;
      if (emailSendsay === '' || emailSendsay === null || emailSendsay === undefined) {
        TweenMax.fromTo('.form', {
          duration: 2.5,
          y: -10,
        }, {
          y: 10,
          ease: 'elastic.out(1, 0.3)',
        });
        console.log('empty value');
        valueInput.focus();
        return;
      }
      const emailFilter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailFilter.test(emailSendsay)) {
        TweenMax.fromTo('.form', {
          duration: 2.5,
          y: -10,
        }, {
          y: 10,
          ease: 'elastic.out(1, 0.3)',
        });
        console.log('invalid email');
        valueInput.focus();
        return;
      }
      this.$refs.buttonSubmit.disabled = true;
      // axios({
      //   method: 'get',
      //   url: 'https://sendsay.ru/form/mts/2',
      //   headers: {
      //     Accept: 'application/json',
      //   },
      // })
      //   .then((response) => {
      //     console.log(response);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      axios({
        method: 'post',
        url: 'https://sendsay.ru/form/mts/2',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        data: {
          _member_email: emailSendsay,
          q923: valueSendsay,
        },
      })
        .then((response) => {
          console.log(response);
          this.$refs.buttonSubmit.disabled = false;
          this.$refs.formMain.classList.add('sendout');
        })
        .catch((error) => {
          console.log(error);
          this.$refs.buttonSubmit.disabled = false;
        });
    },
  },
};
</script>

<style lang="scss">
.footer-section{
  opacity: 0;
  position: relative;
  display: block;
  background-color: #E30611;
  background-image: url('../assets/image/footer-section/noise.png');

  .container{
    padding-top: 120px;
    background-image: url('../assets/image/footer-section/stripes.png');
    background-size: cover;
    height: 100%;
    display: block;
    position: relative;
  }
}
.footer-heading{
  color: #ffffff;
  font-size: 24px;
  line-height: 1.3;
  margin-bottom: 30px;
}
.form{
  background-color: #ffffff;
  border-radius: 15px;
  width: 100%;
  padding: 20px;
  position: relative;

  .thankyou{
    opacity: 0;
    position: absolute;
    top: 50px;
    left: 0;
    font-size: 30px;
    line-height: 1.2;
    text-align: center;

    span{
      font-size: 26px;
      display: block;
      margin-top: 30px;
    }
  }
  .first-input {
    z-index: 10;
    position: relative;
  }

  &.sendout{

    .first-input{
      opacity: 0;
    }

    .thankyou{
      opacity: 1;
    }
  }
}
.form-input{
  flex-direction: column;
  display: flex;

  label{
    font-weight: 500;
    font-size: 10px;
  }
  input{
    border: unset;
  }
  .form-control{
    border-bottom: 1px solid $primary;
    padding: 10px 0;
    line-height: 1;
    font-weight: 500;
    color: #010101;
    font-size: 20px;
    margin-bottom: 20px;

    &:focus{
      outline: 0;
      box-shadow: 0 1px 3px rgba($primary, 0.15);
    }
  }
}

.form-checkbox{
  position: relative;
  line-height: 1.2;
  margin-bottom: 20px;

  input{
    position: absolute;
    left: 0;
    z-index: -1;
    width: 1rem;
    height: 1.25rem;
    opacity: 0;
  }

  &:before {
    position: absolute;
    top: .25rem;
    left: 0;
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 3px;
    pointer-events: none;
    content: '';
    background-color: #fff;
    transition: background .15s ease-in-out;
    border: #adb5bd solid 1px;
  }

  &:after {
    position: absolute;
    top: .25rem;
    left: 0;
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    content: "";
    background: no-repeat 50%/50% 50%;
  }

  label{
    font-size: 12px;
    color: #697884;
    line-height: 1.5;
    display: block;
    z-index: 10;
    position: relative;
    padding-left: 30px;
  }

  &.checkedbox{
    &:before{
      background-color: $primary;
      border: $primary solid 1px;
    }
    &:after{
      background-image: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L5 9L13 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    }
  }
}

.btn{
  background: $primary;
  border-radius: 8px;
  padding: 12px 24px;
  border: 1px solid $primary;
  text-align: center;
  letter-spacing: 0.1rem;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  width: 100%;
  transition: background-color .15s ease-in-out;

  &[disabled]{
    opacity: 0.6;
  }

  &:hover{
    outline: 0;
    background: darken($primary, 10%);
    cursor: pointer;
    color: #fff;
  }
   &:focus {
     outline: 0;
     background: $primary;
   }
}

.gift-image{
  margin: 20px 0;

  img{
    margin: 0 auto;
    display: block;
    max-width: 100%;
  }
}
.instagram-block{
  background: #ffffff;
  margin: 0 -15px;
  width: calc(100% + 30px);
  padding: 15px 15px 30px;
  box-shadow: 0 -16px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.instagram-heading{
  margin-bottom: 15px;
  color: #181818;
  font-size: 22px;
  font-weight: bold;
}
.instagram-about{
  display: flex;
  margin-bottom: 20px;

  &__image{
    flex: 0 0 80px;
    width: 80px;
    height: 80px;
    margin-right: 20px;

    img{
      box-shadow: 0 22px 10px -14px rgba(0, 0, 0, 0.2);
      border-radius: 18px;
      max-width: 100%;
    }
  }

  &__text{
    font-size: 18px;
    color: #697884;
    max-width: 300px
  }
}
.instagram-btn{

  .btn{
    display: block;
    width: 100%;
  }
}
.footer-copyright{
  background-color: #010101;
  text-align: center;
  color: #adb5bd;
  margin: 0 -15px;
  padding: 15px;
  font-size: 12px;
}
</style>
